<div class="c-title--subsection text-uppercase">DEFAULT FILTERS</div>
<div class="row row--builder default-filters">
    <div class="col col-sm-3 default-filters--padding">
        <ccl-multi-select-dropdown
            [placeholder]="'Speaker Type:'"
            [data]="sharedService.speakerTypes"
            [(ngModel)]="speakerDataConfig.defaultFilters.speakerTypes"
            [settings]="speakerTypeDropdownSettings"
        ></ccl-multi-select-dropdown>
    </div>
</div>

<div *ngIf="false" class="c-title--subsection text-uppercase mar-20">DISPLAY STYLE</div>
<div *ngIf="false" class="row row--builder">
    <div class="col col-sm-6 default-filters--padding">
        <label for="styleTemplate">Display Style Template</label>
        <ccl-simple-select formId="styleTemplate"
            [listOfItems]="groupTemplate.group"
            (valueChange)="valueChangeGroup($event)"
            [value]="speakerDataConfig.group"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
</div>

<div class="c-title--subsection text-uppercase mar-20 mar-top-50">GROUPING</div>
<div class="row row--builder">
    <div class="col col-sm-6 default-filters--padding">
        <ccl-simple-select ariaLabel="Grouping"
            [listOfItems]="groupOn.topLevel"
            (valueChange)="valueChangeEvent($event, 'group', false)"
            [value]="speakerDataConfig.topLevel.groupingBy"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
</div>

<div class="c-title--subsection text-uppercase mar-20 mar-top-50">SORTING</div>

<div class="row row--builder">
    <div class="col col-sm-6 default-filters--padding">
        <label for="topGroup">Sort By</label>
        <ccl-simple-select ariaLabel="Sorting"
            [listOfItems]="sortOn.topLevel"
            (valueChange)="valueChangeEvent($event, 'sort', false)"
            [value]="speakerDataConfig.topLevel.sortingBy"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
    <div
        class="col col-sm-3"
    >
        <label for="topDF">Sort Order</label>
        <ccl-simple-select formId="sortOrder"
            [listOfItems]="sortOrder"
            (valueChange)="speakerDataConfig.sort.sortOrder = $event.value"
            [value]="speakerDataConfig.sort.sortOrder"
            [bindLabel]="'label'"
            [bindValue]="'code'"
            [isClearable]="false"
        ></ccl-simple-select>
    </div>
</div>

<hr />
<div class="row row--builder">
    <div class="col-sm-10 c-title--subsection text-uppercase default-filters--padding">
        SECTION PREVIEW
    </div>
    <div class="col-sm-2">
        <ccl-basic-button (clickEvent)="openConfigDrawer('grouping-display-config')" buttonStyle="c-btn--secondary"
            >Grouping Style
        </ccl-basic-button>
    </div>
</div>

<span *ngIf="defaultData"
    ><strong>Note : You don't have any speakers yet, so this preview is based on dummy data.</strong></span
>
<img alt="Loading..." *ngIf="sharedService.loadingList" src="assets/images/loading.gif" />
<div class="pointerEvent" [hidden]="sharedService.loadingList">
    <div #generalList id="generalList" class="mtop50"></div>
</div>
